module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_0.2d51ad6f.png";